import { render, staticRenderFns } from "./tBurialForm.vue?vue&type=template&id=7be3d988&scoped=true"
import script from "./tBurialForm.vue?vue&type=script&lang=js"
export * from "./tBurialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3d988",
  null
  
)

export default component.exports